(function () {

    function OnShopifyAccountOpen() {
        document.body.classList.add('overflow-hidden', 'show-overlay-2')
        document.querySelector('html').classList.add('force-overflow-visible')
    }

    function OnShopifyAccountClose() {
        // Delay close due to Shopify taking ~300ms to remove styles (animation time?)
        setTimeout(() => {
            document.body.classList.remove('overflow-hidden', 'show-overlay-2')
            document.querySelector('html').classList.remove('force-overflow-visible')
        }, 300)
    }

    // Bind event listeners for Shopify Account
    document.querySelector('shopify-account').addEventListener('open', () => OnShopifyAccountOpen());
    document.querySelector('shopify-account').addEventListener('close', () => OnShopifyAccountClose());
})();